import React from 'react';
import { Input as JoyInput, FormControl, FormLabel, FormHelperText } from '@mui/joy';
import { cn } from '@utils/cn';

interface InputProps {
  label?: string;
  placeholder?: string;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  startDecorator?: React.ReactNode;
  endDecorator?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({
  label,
  placeholder,
  type = 'text',
  value,
  onChange,
  error = false,
  helperText,
  required = false,
  disabled = false,
  fullWidth = false,
  size = 'md',
  className,
  startDecorator,
  endDecorator,
}) => {
  return (
    <FormControl 
      error={error} 
      disabled={disabled}
      required={required}
      className={cn(fullWidth && 'w-full', className)}
    >
      {label && (
        <FormLabel className="mb-1 text-sm font-medium">
          {label}
        </FormLabel>
      )}
      <JoyInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        size={size}
        error={error}
        disabled={disabled}
        fullWidth={fullWidth}
        startDecorator={startDecorator}
        endDecorator={endDecorator}
        className={cn(
          'transition-all duration-200',
          'focus-within:shadow-sm'
        )}
      />
      {helperText && (
        <FormHelperText className="mt-1 text-xs">
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};